import script from "./UploadFolderDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./UploadFolderDetails.vue?vue&type=script&setup=true&lang=ts"

import "./UploadFolderDetails.vue?vue&type=style&index=0&id=78bda380&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78bda380"]])

export default __exports__